module.exports = {
  NODE_ENV: 'development',
  API_ENDPOINT: 'https://admin.revenue.co.ke/api/v2',
}
